export const APP_VERSION = "0.3.14";
export const APP_VERSION_NAME = "Production data and Clerk identity sync";
export const APP_VERSION_DATE = "2026-07-23";

export function appVersionLabel() {
  return `LexMosaic v${APP_VERSION}`;
}
